import { Button } from "ui/components/button";
import React from "react";
import { toast } from "sonner";

const withClipboard = (WrappedComponent) => {
  return function WithClipboardComponent(props) {
    const copyToClipboard = (containerId) => {
      const container = document.getElementById(containerId);

      if (!container) {
        toast.error(`Element with ID '${containerId}' not found.`);
        return;
      }

      const html = container.innerHTML;

      if (navigator.clipboard && window.ClipboardItem) {
        const clipboardItem = new ClipboardItem({
          "text/plain": new Blob([html], { type: "text/plain" }),
          "text/html": new Blob([html], { type: "text/html" }),
        });

        navigator.clipboard
          .write([clipboardItem])
          .then(() => {
            toast("Copied to clipboard");
          })
          .catch((error) => {
            console.error("Failed to copy:", error);
            toast.error("Failed to copy the content. Please try again.");
          });
      } else {
        const textArea = document.createElement("div");

        textArea.contentEditable = true;
        textArea.innerHTML = html;
        document.body.appendChild(textArea);
        textArea.focus();
        document.execCommand("selectAll");
        try {
          document.execCommand("copy");
          toast("Copied to clipboard");
        } catch (error) {
          console.error("Failed to copy:", error);
          toast.error("Failed to copy the content. Please try again.");
        }
        document.body.removeChild(textArea);
      }
    };

    return (
      <div className="relative">
        <WrappedComponent {...props} />
        <div className="space-x-4 mt-4 ml-4">
          <Button onClick={() => copyToClipboard(props.id)}>Copy</Button>
        </div>
      </div>
    );
  };
};

export default withClipboard;
